const memoryGame = document.querySelector('.memory-game');

if (memoryGame) {
  const setModalOpen = (isOpen) => document.body.classList.toggle('noscroll', isOpen);

  const $ = (id) => document.getElementById(id);

  const shuffle = (arr) => {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };

  const PAIRS_DATABASE = JSON.parse($('board').dataset.tiles).map((t, i) => ({
    id: `pair-${i + 1}`,
    itemA: { name: t.item_a.text__name || '', image: t.item_a.image__image },
    itemB: { name: t.item_b.text__name || '', image: t.item_b.image__image },
    explain: t.wysiwyg__explain,
  }));

  const LEVELS = {
    1: { pairs: 6, cols: 4, label: memoryGame.dataset.levelOne, multiplier: 1.0 },
    2: { pairs: 8, cols: 4, label: memoryGame.dataset.levelTwo, multiplier: 1.3 },
    3: { pairs: 12, cols: 6, label: memoryGame.dataset.levelThree, multiplier: 1.6 },
  };

  const SCORE_BASE_PER_PAIR = 100;
  const SCORE_PENALTY_PER_EXTRA_MOVE = 6;
  const SCORE_PENALTY_PER_SECOND = 1.5;

  const state = {
    level: null,
    tiles: [],
    flipped: [],
    matchedPairs: 0,
    totalPairs: 0,
    moves: 0,
    startTime: null,
    timerInterval: null,
    busy: false,
    showExplain: true,
  };

  const el = {
    screenStart: $('screen-start'),
    screenGame: $('screen-game'),
    board: $('board'),
    lvlLabel: $('lvl-label'),
    timerDisplay: $('timer-display'),
    progressLabel: $('progress-label'),
    progressRects: $('progress-rects'),
    pairModal: $('pair-modal'),
    pairImagesWrap: $('pair-images-wrap'),
    pairExplainText: $('pair-explain-text'),
    closePairModal: $('close-pair-modal'),
    continueGameBtn: $('continue-game-btn'),
    endModal: $('end-modal'),
    closeEndModal: $('close-end-modal'),
    endPairs: $('end-pairs'),
    endTime: $('end-time'),
    endMoves: $('end-moves'),
    endScore: $('end-score'),
    endActionsMain: $('end-actions-main'),
    btnPlayAgain: $('btn-play-again'),
    btnInviteFriend: $('btn-invite-friend'),
    btnGiveaway: $('btn-giveaway'),
    inviteFormWrap: $('invite-form-wrap'),
    giveawayFormWrap: $('giveaway-form-wrap'),
    saveScoreWrap: $('save-score-wrap'),
    saveScoreForm: $('save-score-form'),
    playerNameInput: $('player-name-input'),
    playerEmailInput: $('player-email-input'),
    playerPolicyCheckbox: $('player-policy'),
    leaderboardWrap: $('leaderboard-wrap'),
  };

  let pendingHideUids = null;

  const emailIsValid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const updateSaveScoreState = () => {
    const nameOk = el.playerNameInput.value.trim().length > 0;
    const emailOk = emailIsValid(el.playerEmailInput.value.trim());
    const policyOk = el.playerPolicyCheckbox.checked;

    const isValid = nameOk && emailOk && policyOk;

    el.saveScoreForm.querySelector('.btn').classList.toggle('is-disabled', !isValid);
  };

  const calculateScore = (level, pairs, moves, seconds) => {
    const cfg = LEVELS[level];
    const base = SCORE_BASE_PER_PAIR * pairs * cfg.multiplier;
    const extraMoves = Math.max(0, moves - pairs);
    const penalty = extraMoves * SCORE_PENALTY_PER_EXTRA_MOVE + seconds * SCORE_PENALTY_PER_SECOND;
    return Math.max(0, Math.round(base - penalty));
  };

  const getTileEl = (uid) => el.board.querySelector(`.tile[data-uid="${uid}"]`);
  const formatTime = (s) => `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
  const getElapsedSeconds = () => (state.startTime ? Math.floor((Date.now() - state.startTime) / 1000) : 0);

  const showMark = (uid, type) => {
    const mark = document.createElement('div');
    mark.className = `mark ${type}`;
    mark.textContent = type === 'ok' ? '✓' : '✕';
    getTileEl(uid)?.appendChild(mark);
  };

  const clearMarks = () => el.board.querySelectorAll('.mark').forEach((m) => m.remove());

  const hideMatchedTiles = (uidA, uidB) => {
    getTileEl(uidA)?.classList.add('hiding');
    getTileEl(uidB)?.classList.add('hiding');
  };

  const renderProgress = () => {
    el.progressRects.innerHTML = Array.from({ length: state.totalPairs }, () => '<div class="p-rect"></div>').join('');
  };

  const updateProgressRects = () => {
    el.progressRects.querySelectorAll('.p-rect').forEach((r, i) => r.classList.toggle('found', i < state.matchedPairs));
  };

  const updateProgressLabel = () => {
    el.progressLabel.textContent = `${state.matchedPairs}/${state.totalPairs}`;
  };

  const stopTimer = () => {
    clearInterval(state.timerInterval);
    state.timerInterval = null;
  };

  const startTimer = () => {
    stopTimer();
    state.startTime = Date.now();
    el.timerDisplay.textContent = '00:00';
    state.timerInterval = setInterval(() => {
      el.timerDisplay.textContent = formatTime(getElapsedSeconds());
    }, 500);
  };

  const closeAllForms = () => {
    el.inviteFormWrap.classList.add('hidden');
    el.giveawayFormWrap.classList.add('hidden');
    el.btnInviteFriend.classList.remove('hidden');
    el.btnGiveaway.classList.remove('hidden');
  };

  const showEndModal = () => {
    stopTimer();
    const seconds = getElapsedSeconds();
    const score = calculateScore(state.level, state.matchedPairs, state.moves, seconds);
    Object.assign(state, { lastScore: score, lastSeconds: seconds });

    el.endPairs.textContent = `${state.matchedPairs}/${state.totalPairs}`;
    el.endTime.textContent = formatTime(seconds);
    el.endMoves.textContent = state.moves;
    el.endScore.textContent = score;
    localData.siteData = `${score}-${state.moves}-${formatTime(seconds)}-${state.level}`;

    closeAllForms();
    el.endActionsMain.classList.add('hidden');

    el.saveScoreWrap.classList.remove('hidden');
    el.saveScoreForm.classList.remove('hidden');
    el.playerNameInput.value = '';
    el.playerEmailInput.value = '';
    el.playerPolicyCheckbox.checked = false;

    el.leaderboardWrap.classList.add('hidden');
    el.endModal.classList.remove('hidden');

    updateSaveScoreState();

    setModalOpen(true);
  };

  const afterPairResolved = () => {
    if (state.matchedPairs >= state.totalPairs) setTimeout(showEndModal, 400);
  };

  const openPairModal = (pairData, uidA, uidB) => {
    pendingHideUids = [uidA, uidB];

    el.pairImagesWrap.innerHTML = `
      <div class="winning-card">
        <div class="winning-card-image" style="background-image:url('${pairData.itemA.image}')"></div>
      </div>
      <div class="plus">=</div>
      <div class="winning-card">
        <div class="winning-card-image" style="background-image:url('${pairData.itemB.image}')"></div>
      </div>`;

    el.pairExplainText.innerHTML = pairData.explain;
    el.pairModal.classList.remove('hidden');
    setModalOpen(true);
  };

  const closePairModalFn = () => {
    el.pairModal.classList.add('hidden');
    if (pendingHideUids) {
      hideMatchedTiles(...pendingHideUids);
      pendingHideUids = null;
    }
    afterPairResolved();
    setModalOpen(false);
  };

  const checkMatch = () => {
    const [uidA, uidB] = state.flipped;
    const [tileA, tileB] = [uidA, uidB].map((uid) => state.tiles.find((t) => t.uid === uid));
    const [elA, elB] = [uidA, uidB].map(getTileEl);

    if (tileA.pairId === tileB.pairId) {
      showMark(uidA, 'ok');
      showMark(uidB, 'ok');

      setTimeout(() => {
        tileA.matched = true;
        tileB.matched = true;

        elA.classList.add('matched');
        elB.classList.add('matched');
        clearMarks();

        state.matchedPairs++;
        updateProgressRects();
        updateProgressLabel();

        state.flipped = [];
        state.busy = false;

        const pairData = PAIRS_DATABASE.find((p) => p.id === tileA.pairId);

        if (state.showExplain) {
          openPairModal(pairData, uidA, uidB);
        } else {
          hideMatchedTiles(uidA, uidB);
          afterPairResolved();
        }
      }, 650);
    } else {
      showMark(uidA, 'no');
      showMark(uidB, 'no');

      setTimeout(() => {
        tileA.flipped = false;
        tileB.flipped = false;

        elA.classList.remove('flipped', 'wrong');
        elB.classList.remove('flipped', 'wrong');
        clearMarks();

        state.flipped = [];
        state.busy = false;
      }, 900);
    }
  };

  const onTileClick = (uid) => {
    if (state.busy) return;
    const tile = state.tiles.find((t) => t.uid === uid);
    if (!tile || tile.matched || tile.flipped || state.flipped.length >= 2) return;

    tile.flipped = true;
    getTileEl(uid).classList.add('flipped');
    state.flipped.push(uid);

    if (state.flipped.length === 2) {
      state.moves++;
      state.busy = true;
      checkMatch();
    }
  };

  const renderBoard = () => {
    el.board.innerHTML = '';

    state.tiles.forEach((tile) => {
      const tileEl = document.createElement('div');
      tileEl.className = 'tile';
      tileEl.dataset.uid = tile.uid;

      tileEl.innerHTML = `
        <div class="tile-inner">
          <div class="tile-face tile-back"></div>
          <div class="tile-face tile-front">
            <div class="tile-image" style="background-image:url('${tile.item.image}')"></div>
            <div class="name">${tile.item.name}</div>
          </div>
        </div>`;

      tileEl.addEventListener('click', () => onTileClick(tile.uid));
      el.board.appendChild(tileEl);
    });
  };

  const startGame = (level) => {
    const cfg = LEVELS[level];

    Object.assign(state, {
      level,
      totalPairs: cfg.pairs,
      matchedPairs: 0,
      moves: 0,
      flipped: [],
      busy: false,
    });

    state.tiles = shuffle(
      shuffle(PAIRS_DATABASE)
        .slice(0, cfg.pairs)
        .flatMap((pair) => [
          { uid: `${pair.id}-A`, pairId: pair.id, item: pair.itemA, matched: false, flipped: false },
          { uid: `${pair.id}-B`, pairId: pair.id, item: pair.itemB, matched: false, flipped: false },
        ]),
    );

    el.lvlLabel.textContent = cfg.label;
    el.board.className = `board lvl-${level}`;

    renderBoard();
    renderProgress();
    updateProgressLabel();

    el.screenStart.classList.add('hidden');
    el.screenGame.classList.remove('hidden');

    startTimer();
  };

  const showSubForm = (wrap, btn) => {
    closeAllForms();
    wrap.classList.remove('hidden');
    btn.classList.add('hidden');
  };

  document
    .querySelectorAll('.level-card')
    .forEach((card) => card.addEventListener('click', () => startGame(parseInt(card.dataset.level, 10))));

  $('btn-back-to-start').addEventListener('click', () => {
    stopTimer();
    el.screenGame.classList.add('hidden');
    el.screenStart.classList.remove('hidden');
  });

  el.closePairModal.addEventListener('click', closePairModalFn);
  el.continueGameBtn.addEventListener('click', closePairModalFn);
  el.closeEndModal.addEventListener('click', () => {
    el.endModal.classList.add('hidden');
    setModalOpen(false);
    closeAllForms();
    stopTimer();
    el.screenGame.classList.add('hidden');
    el.screenStart.classList.remove('hidden');
  });

  el.btnPlayAgain.addEventListener('click', () => {
    el.endModal.classList.add('hidden');
    el.endModal.classList.add('hidden');
    setModalOpen(false);
    closeAllForms();
    stopTimer();
    el.screenGame.classList.add('hidden');
    el.screenStart.classList.remove('hidden');
  });

  el.playerNameInput.addEventListener('input', updateSaveScoreState);
  el.playerEmailInput.addEventListener('input', updateSaveScoreState);
  el.playerPolicyCheckbox.addEventListener('change', updateSaveScoreState);

  el.saveScoreForm.querySelector('button').addEventListener('click', (e) => {
    e.preventDefault();

    const name = el.playerNameInput.value.trim();
    const email = el.playerEmailInput.value.trim();
    const checked = el.playerPolicyCheckbox;
    if (!name || !email || !checked.checked) return;

    el.saveScoreForm.classList.add('hidden');
    el.leaderboardWrap.classList.remove('hidden');
    el.endActionsMain.classList.remove('hidden');
  });

  el.btnInviteFriend.addEventListener('click', () => {
    showSubForm(el.inviteFormWrap, el.btnInviteFriend);
    el.leaderboardWrap.classList.add('hidden');
  });

  el.btnGiveaway.addEventListener('click', () => {
    showSubForm(el.giveawayFormWrap, el.btnGiveaway);
    el.leaderboardWrap.classList.add('hidden');
  });

  const showLeaderboardBtn = document.querySelector('.show-leaderboard');
  showLeaderboardBtn?.addEventListener('click', () => {
    document.querySelector('.memory-game__leaderboard')?.classList.remove('hidden');
    showLeaderboardBtn.classList.add('hidden');
  });
}
